export default __webpack_public_path__ + "static/media/padel-firstServe-thumbnail.170b721e.png";